import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { IntlService } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs';

import { AccountMenuItemBase } from '../account-menu-item-base';
import { AccountMenuVipService } from '../account-menu-vip.service';
import { CoralCashback } from '../account-menu.models';
import { CoralCashbackLevelComponent } from './coral-cashback-level.component';

/**
 * NOTE: not used in v2
 */
@Component({
    imports: [CoralCashbackLevelComponent, TrustAsHtmlPipe],
    selector: 'lh-am-coral-cashback',
    templateUrl: 'coral-cashback.html',
})
export class CoralCashbackComponent extends AccountMenuItemBase implements OnDestroy, OnInit {
    private readonly intlService = inject(IntlService);
    private readonly accountMenuVipService = inject(AccountMenuVipService);

    model: any;
    nonVipMessage: string;
    private readonly unsubscribe = new Subject<void>();

    ngOnInit() {
        if (this.accountMenuVipService.ignoreVipLevel || this.accountMenuVipService.isVip) {
            this.accountMenuService.coralCashbackEvents
                .pipe(
                    filter((d): d is CoralCashback => d != null),
                    takeUntil(this.unsubscribe),
                )
                .subscribe((data) => {
                    this.model = {
                        title: this.accountMenuService.resources.messages['CoralCashbackTitle'],
                        currentPoints: this.accountMenuService.resources.messages['CoralCashbackCurrentPoints']!.replace(
                            '{POINTS}',
                            data.currentPoints.toString(),
                        ),
                        cashValue: this.accountMenuService.resources.messages['CoralCashbackCashValue']!.replace(
                            '{AMOUNT}',
                            this.intlService.formatCurrency(data.cashbackAmount / 100, data.cashbackCurrency),
                        ),
                        minRequiredPointsForRedeem: this.accountMenuService.resources.messages['CoralCashbackMinRequiredPoints']!.replace(
                            '{MIN_POINTS}',
                            data.minPointsReqForRedeem.toString(),
                        ),
                    };
                });
            this.accountMenuService.updateCoralCashback();
        } else {
            this.nonVipMessage = this.accountMenuService.resources.messages['CoralCashbackNonVipMessage']!;
        }
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
